(() => {
  const ROOT = '[data-ffs-collection-search]';

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const tokens = (query) => normalize(query).split(/\s+/).filter(Boolean);

  const currentInput = () => document.querySelector(`${ROOT} .ffs-collection-search__input`);

  const currentQuery = () => {
    const input = currentInput();
    return input ? input.value : '';
  };

  let originalCounts = null;

  /* The grid is paged. While a search is active, the other pages' cards are
     fetched once (section rendering) and shown alongside this page's cards so
     the search still covers the whole collection. Cleared search = detached. */
  const extraState = new WeakMap();

  const gridPages = (grid) => parseInt(grid.dataset.ffsPages || '1', 10) || 1;

  const loadOtherPages = (grid) => {
    let state = extraState.get(grid);
    if (state) return state.loading;
    state = { items: [], ready: false, attached: false, loading: null };
    extraState.set(grid, state);
    const pages = gridPages(grid);
    const current = parseInt(grid.dataset.ffsPage || '1', 10) || 1;
    const sectionId = grid.dataset.id;
    const requests = [];
    for (let page = 1; page <= pages && sectionId; page += 1) {
      if (page === current) continue;
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      requests.push(
        fetch(url.toString(), { credentials: 'same-origin' })
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('#product-grid > .grid__item[data-ffs-search]')).map((item) => {
              item.dataset.ffsExtraPage = String(page);
              item.dataset.ffsBefore = page < current ? 'true' : 'false';
              return item;
            });
          })
          .catch(() => [])
      );
    }
    state.loading = Promise.all(requests).then((groups) => {
      state.items = groups.flat();
      state.ready = true;
      return state.items;
    });
    return state.loading;
  };

  const attachExtras = (grid) => {
    const state = extraState.get(grid);
    if (!state || !state.ready || state.attached) return;
    const firstOwn = grid.querySelector(':scope > .grid__item:not([data-ffs-extra-page])');
    state.items.forEach((item) => {
      if (item.dataset.ffsBefore === 'true' && firstOwn) grid.insertBefore(item, firstOwn);
      else grid.appendChild(item);
    });
    state.attached = true;
  };

  const detachExtras = (grid) => {
    const state = extraState.get(grid);
    if (!state || !state.attached) return;
    state.items.forEach((item) => item.remove());
    state.attached = false;
  };

  const setSearchMode = (grid, active) => {
    grid.classList.toggle('ffs-grid-truncate', !active && grid.dataset.ffsTruncate === 'true');
    document.querySelectorAll('.pagination-wrapper').forEach((nav) => {
      nav.hidden = active;
    });
  };

  const snapshotCounts = () => {
    if (originalCounts) return;
    originalCounts = Array.from(document.querySelectorAll('#ProductCountDesktop, #ProductCount')).map(
      (node) => node.innerHTML
    );
  };

  const restoreCounts = () => {
    if (!originalCounts) return;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach((node, index) => {
      if (originalCounts[index] != null) node.innerHTML = originalCounts[index];
    });
  };

  const apply = (query) => {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    snapshotCounts();

    const terms = tokens(query);
    if (gridPages(grid) > 1) {
      if (terms.length) {
        const state = extraState.get(grid);
        if (!state || !state.ready) {
          loadOtherPages(grid).then(() => {
            if (tokens(currentQuery()).length) apply(currentQuery());
          });
        }
        attachExtras(grid);
      } else {
        detachExtras(grid);
      }
      setSearchMode(grid, terms.length > 0);
    }

    const items = grid.querySelectorAll('.grid__item[data-ffs-search]');
    let shown = 0;

    items.forEach((item) => {
      const hay = item.getAttribute('data-ffs-search') || '';
      const match = terms.every((term) => hay.includes(term));
      item.classList.toggle('ffs-collection-search-hidden', !match);
      item.toggleAttribute('hidden', !match);
      if (match) shown += 1;
    });

    const empty = document.getElementById('FfsCollectionSearchEmpty');
    if (empty) {
      const stillLoading = gridPages(grid) > 1 && !(extraState.get(grid) || {}).ready;
      empty.hidden = !(terms.length && shown === 0 && items.length > 0 && !stillLoading);
      const queryEl = empty.querySelector('[data-ffs-search-query]');
      if (queryEl) queryEl.textContent = query.trim();
    }

    document.querySelectorAll(`${ROOT} .ffs-collection-search__clear`).forEach((button) => {
      button.classList.toggle('hidden', !query.trim());
    });

    if (!terms.length) {
      restoreCounts();
      return;
    }

    const label = shown === 1 ? '1 match' : `${shown} matches`;
    document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach((node) => {
      node.textContent = label;
    });
  };

  const isSearchInput = (target) =>
    target instanceof HTMLInputElement && target.classList.contains('ffs-collection-search__input');

  document.addEventListener(
    'input',
    (event) => {
      if (!isSearchInput(event.target)) return;
      event.stopPropagation();
      apply(event.target.value);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (!isSearchInput(event.target)) return;
      if (event.key === 'Enter') event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener('click', (event) => {
    const clear = event.target.closest(`${ROOT} .ffs-collection-search__clear`);
    if (!clear) return;
    const input = currentInput();
    if (!input) return;
    input.value = '';
    input.focus();
    apply('');
  });

  const start = () => apply(currentQuery());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('ffs:catch-slot-updated', () => {
    originalCounts = null;
    apply(currentQuery());
  });
})();
